import React from 'react';
import LineChart from '../../../charts/LineChart02';
import { useState, useEffect } from 'react';
import ScheduleFreqFilter from './ScheduleFreqFilter'

// Import utilities
import { tailwindConfig } from '../../../utils/Utils';

function ScheduleFrequencyCard({title, data}) {

  const [chartData, setChartData] = useState({});
  const [freqFilter, setFreqFilter] = useState(['Games', 'Shopping', 'Lifestyle', 'Health & Fitness', 'Travel & Local']);
  const [audiences, setAudiences] = useState([])
  const random = () => Math.floor(Math.random() * 255);

  useEffect(() => {
    var datasets = []
    var markets = []
    if('datasets' in data)
      for(var audience in data.datasets){
        markets.push(audience)
        if(freqFilter.length>0) {
          if (freqFilter.includes(audience)) {
            var color = `rgb(${random()}, ${random()}, ${random()})`
            data.datasets[audience]['borderColor'] = color
            data.datasets[audience]['fill'] = false
            data.datasets[audience]['borderWidth'] = 2
            data.datasets[audience]['tension'] = 0
            data.datasets[audience]['pointRadius'] = 0
            data.datasets[audience]['pointHoverRadius'] = 3
            data.datasets[audience]['pointBackgroundColor'] = color
            data.datasets[audience]['clip'] = 20
            datasets.push(data.datasets[audience])
          }
        }
        else{
          var color = `rgb(${random()}, ${random()}, ${random()})`
          data.datasets[audience]['borderColor'] = color
          data.datasets[audience]['fill'] = false
          data.datasets[audience]['borderWidth'] = 2
          data.datasets[audience]['tension'] = 0
          data.datasets[audience]['pointRadius'] = 0
          data.datasets[audience]['pointHoverRadius'] = 3
          data.datasets[audience]['pointBackgroundColor'] = color
          data.datasets[audience]['clip'] = 20
          datasets.push(data.datasets[audience])
        }
      }
    setChartData({
      labels: data.labels,
      datasets: datasets,
    })
    setAudiences(markets)
  },[data, freqFilter]);

  const formatValue = (value) => Intl.NumberFormat('en-US', {
    style: 'decimal',
    maximumSignificantDigits: 2,
    notation: 'compact',
  }).format(value);

  function applyFilter(filters){
    setFreqFilter(filters)
  }

  return (
    <div className="flex flex-col col-span-full sm:col-span-6 bg-white shadow-1 rounded-sm border border-slate-200">
      <header className="px-5 py-4 border-b border-slate-100 flex items-center">
        <h2 className="font-semibold text-slate-800">{title}</h2>
        <div className="ml-auto">
          <ScheduleFreqFilter options={audiences} applyFilter={applyFilter}/>
        </div>

      </header>
      {/* Chart built with Chart.js 3 */}
      {/* Change the height attribute to adjust the chart height */}
      {'labels' in chartData && chartData.labels != undefined ?
        <LineChart data={chartData} width={595} height={248} formatValue={formatValue}/> :
        <div className="sm:flex justify-items-center mt-5 w-full mb-5">
          <div className="m-auto text-center">
            <svg className="animate-spin h-8 w-full mb-2" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="45" stroke="#F7699F" strokeWidth="10" fill="transparent" strokeLinecap="round"
                      strokeDasharray="283" strokeDashoffset="75"/>
            </svg>
            <p className="w-full">
              Loading Frequency Chart...
            </p>
          </div>
        </div>
      }
    </div>
  );
}

export default ScheduleFrequencyCard;
